// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global simpleParallax, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        initLoaded: false,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __handleAccordions: function() {
            wntrTheme.body.find('.accordions__intro-description-toggle').on('click', function() {
                $(this).toggleClass('accordions__intro-description-toggle--active');
                $(this).closest('.accordions__intro').find('.accordions__intro-description-foldable').toggleClass('accordions__intro-description-foldable--active');
            });

            if(wntrTheme.body.find('.handorgel')) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0], {});
                });
            }
        },

        __handleParallaxBanner: function() {
            const image = document.getElementsByClassName('image__banner-image');
            new simpleParallax(image, {
                //delay: 0,
                //orientation: 'down',
                //scale: 1.3,
                //overflow: true,
                //customContainer: '.container',
                //customWrapper: '.wrapper'
            });
        },

        /*
        * Video banner handler
        */
        __videoBannerHandler: function() {
            const play = wntrTheme.body.find('.video__banner-play');

            if(play.length) {
                play.on('click', function() {
                    const player = $(this).siblings('.video__banner-player');
                    if(player.length && player.hasClass('is-hidden')) {
                        player.removeClass('is-hidden');
                        const iframe = player.children('iframe');
                        const iframeSrc = $(iframe).attr('src');
                        iframe.prop('src', iframeSrc + '&autoplay=1&showinfo=0&showsearch=0&rel=0&modestbranding=1');
                        iframe.find('.ytp-button').trigger();
                    }
                });
            }
        },

        /*
        * Handle sidebar links effect
        */
        __handleSidebarLinks: () => {
            const blocks = wntrTheme.body.find('.block-heading');
            const links = wntrTheme.body.find('.sidebar-link');
            $(document).scroll(function() {
                if($(window).width() > 1024) {
                    blocks.each(function() {
                        if($(document).scrollTop() >= $(this).offset().top - 21) {
                            links.removeClass('is-active');
                            $("a[href*=" + $(this).attr('id') + "]").addClass('is-active');
                        }

                        if($(window).scrollTop() + $(window).height() === $(document).height()) {
                            links.removeClass('is-active');
                            links.last().addClass('is-active');
                        }
                    });
                }
            });

            if($(window).width() > 1024) {
                if($(window).scrollTop() <= 0) {
                    links.first().addClass('is-active');
                }
                links.on('click', function() {
                    $(this).addClass('is-active');
                });
            }
        },

        /*
        * Read more handler
        */
        __readMoreHandler: function() {
            const toggle = wntrTheme.body.find('.btn--toggle-more');
            const content = wntrTheme.body.find('.agenda__block-text');
            const bullets = wntrTheme.body.find('.bullet__block ul');

            bullets.each(function() {
                if($(this).innerHeight() >= 250) {
                    $(this).addClass('has-toggle-content');
                    $(this).siblings('.btn--toggle-more').addClass('is-visible');
                }
            });

            content.each(function() {
                if($(this).innerHeight() >= 500) {
                    $(this).addClass('has-toggle-content');
                    $(this).siblings('.btn--toggle-more').addClass('is-visible');
                }
            });

            if(toggle.length) {
                toggle.on('click', function() {
                    if(!$(this).hasClass('is-toggled')) {
                        $(this).siblings('.has-toggle-content').addClass('is-toggled');
                        $(this).addClass('is-toggled');
                    } else {
                        $(this).siblings('.has-toggle-content').removeClass('is-toggled');
                        $(this).removeClass('is-toggled');
                    }
                });
            }
        },

        /*
        * SoMe handler
        */
        __someHandler: function() {
            const toggleInstagram = wntrTheme.body.find('.some__action--instagram');
            const toggleFacebook = wntrTheme.body.find('.some__action--facebook');
            const instagram = wntrTheme.body.find('.some__instagram');
            const facebook = wntrTheme.body.find('.some__facebook');

            toggleInstagram.on('click', () => {
                facebook.removeClass('is-active');
                instagram.addClass('is-active');
                toggleInstagram.addClass('is-active');
                toggleFacebook.removeClass('is-active');
            });
            toggleFacebook.on('click', () => {
                instagram.removeClass('is-active');
                facebook.addClass('is-active');
                toggleFacebook.addClass('is-active');
                toggleInstagram.removeClass('is-active');
            });
        },

        /*
        * Smooth scroll
        */
        __smoothScrolling: function() {
            $('a[href^="#"]').click(function(event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $(String($.attr(this, 'href'))).offset().top - 20
                }, 500);
                return false;
            });
        },

        /*
        * Facetwp
        */
        __facetwp: function() {
            document.addEventListener('facetwp-refresh', function() {
                toggleFacets();
            });

            document.addEventListener('facetwp-loaded', function() {
                toggleFacets();
                wntrTheme.body.find('.candidates__grid--all').removeClass('is-loading');
                wntrTheme.body.find('.candidates__municipality--all').removeClass('is-loading');
            });

            function toggleFacets() {
                wntrTheme.body.find('.candidates__grid--all').addClass('is-loading');
                wntrTheme.body.find('.candidates__municipality--all').addClass('is-loading');
                if(wntrTheme.initLoaded) {
                    const selectorValue = $('.facetwp-facet-kommun').find('.fs-label').text();
                    wntrTheme.body.find('.candidates__municipality--all').text(selectorValue);
                    if(selectorValue === "Alla kommuner") {
                        wntrTheme.body.find('.candidates__municipality--all').hide();
                        wntrTheme.body.find('.candidates__grid--all').addClass('is-hidden');

                        wntrTheme.body.find('.candidates__municipality--single').show();
                        wntrTheme.body.find('.candidates__grid--single').show();
                    } else {
                        wntrTheme.body.find('.candidates__municipality--single').hide();
                        wntrTheme.body.find('.candidates__municipality--all').show();
                        wntrTheme.body.find('.candidates__grid--all').removeClass('is-hidden');
                        wntrTheme.body.find('.candidates__grid--single').hide();
                    }

                }
                wntrTheme.initLoaded = true;
            }
        },

        /**
         * Mobile menu toggle
         */
        __toggleMobileMenu: function() {
            const menuBtn = wntrTheme.body.find('.hamburger');
            const headerEl = wntrTheme.body.find('.header');
            const menuHeading = wntrTheme.body.find('.menu-item-has-children');

            menuBtn.on('click', function() {
                $(this).toggleClass('is-active');
                headerEl.toggleClass('active-header');
                wntrTheme.body.toggleClass('body--fixed');
            });

            if($(window).width() > 1024) {
                menuHeading.each(function() {
                    $(this).on('mouseover', function() {
                        $(this).addClass('is-active');
                        $(this).find('.header__toggle-sub-menu').addClass('is-active');
                    });

                    $(this).on('mouseout', function() {
                        $(this).removeClass('is-active');
                        $(this).find('.header__toggle-sub-menu').removeClass('is-active');
                    });
                });
            } else {
                menuHeading.each(function() {
                    $(this).on('click', function(e) {
                        if($(e.target).is('a')) {
                            return;
                        }
                        $(this).toggleClass('is-active');
                        $(this).closest('.menu-item').find('.header__toggle-sub-menu').toggleClass('is-active');
                    });

                    if($(this).find('li').hasClass('current-menu-item')) {
                        $(this).addClass('is-active');
                        $(this).find('.header__toggle-sub-menu').addClass('is-active');
                    }
                });
            }
        },

        /**
         * Bottom bar
         */
        __bottomBar: function() {
            const bottomBar = wntrTheme.body.find('.scroll__top-bar');

            $(document).scroll(function() {
                const y = $(this).scrollTop();
                if(y > 800) {
                    bottomBar.addClass('showing');
                } else {
                    bottomBar.removeClass('showing');
                }
            });

            bottomBar.on('click', function() {
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            });
        },

        /**
         * Slider
         */
        __objectSlider: function() {
            const objectSlider = wntrTheme.body.find('.slider');
            if(objectSlider.length) {
                objectSlider.slick({
                    dots: true,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    slidesToShow: 1,
                    centerMode: true,
                    responsive: [
                        {
                            breakpoint: 560,
                            settings: {
                                arrows: false,
                            }
                        }
                    ]
                });
            }
        },


        /**
         * Search toggle
         */
        __toggleSearch: function() {
            const searchBtn = wntrTheme.body.find('.header__search-btn');
            const body = wntrTheme.body;
            const searchWrapper = wntrTheme.body.find('.header__search-wrapper');
            const searchCloseBtn = wntrTheme.body.find('.header__close-search');
            const searchInput = wntrTheme.body.find('.header__search-input');

            $(document).mouseup(function(e) {
                // if the target of the click isn't the container nor a descendant of the container
                if(!searchWrapper.is(e.target) && searchWrapper.has(e.target).length === 0) {
                    searchWrapper.removeClass('active');
                }
            });
            searchBtn.on('click', function() {
                searchWrapper.addClass('active');
                body.addClass('overlay');
                searchInput.focus();
            });

            searchCloseBtn.on('click', function() {
                searchWrapper.removeClass('active');
                body.removeClass('overlay');
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);